import dayjs from 'dayjs'
import Swal from 'sweetalert2'
import { isEmpty } from 'lodash'
import withReactContent from 'sweetalert2-react-content'

const calendar = require('dayjs/plugin/calendar')
const MySwal = withReactContent(Swal)
dayjs.extend(calendar)

function shuffleArray (array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1))
    var temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}
const helpers = {
  currencyFormat: (number = '') => {
    return new Intl.NumberFormat('en-IN', {}).format(number)
  },
  dateFormat: (date, timeZone) => {
    const convertedDate = new Date(date).toLocaleString(undefined, {
      timeZone: timeZone || 'Asia/Kolkata'
    })

    return convertedDate.toString()
  },
  msgDateFormat: (date, timeZone) => {
    const convertedDate = new Date(date).toLocaleDateString(undefined, {
      timeZone: timeZone || 'Asia/Kolkata'
    })

    return convertedDate.toString()
  },
  matchDateTime: (date, timeZone) => {
    return dayjs(date).calendar(null, {
      sameDay: 'h:mm A',
      nextDay: '[Tomorrow]',
      nextWeek: 'dddd [at] h:mm A',
      lastDay: '[Yesterday at] h:mm A',
      lastWeek: '[Last] dddd [at] h:mm A',
      sameElse: 'DD/MM/YYYY'
    })
  },

  isInputNumber: event => {
    const char = String.fromCharCode(event.which)
    if (!/[0-9]/.test(char)) {
      event.preventDefault()
    }
  },
  alertFunction: (title, item, changeFunction, deleteIcon) => {
    MySwal.fire({
      html: <strong>{title}</strong>,
      icon: deleteIcon ? 'error' : 'warning',
      showConfirmButton: 'Okay',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        changeFunction(item)
      }
    })
  },
  downloadFile: url => {
    if (isEmpty(url)) {
      alert('Invalid URL')
      return false
    }
    const parts = url.split('/')
    const filename = parts[parts.length - 1]
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onload = () => {
      const a = document.createElement('a')
      const urls = window.URL.createObjectURL(xhr.response)
      a.href = urls
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(urls)
    }
    xhr.send()
  },
  setDebouncingFunction: payload => {
    if (!payload.isInitialized) {
      payload.setIsInitialized(true)
    } else if (payload.searchTerm || !payload.filterData?.isReset) {
      payload.setFilterData({
        ...payload.filterData,
        isReset: false,
        searchKey: payload.debouncedSearchTerm
          ? payload.debouncedSearchTerm
          : '',
        isFilter: payload.debouncedSearchTerm ? true : false
      })
      payload.setPage(1)
    }
  },
  ternaryCondition: (condition, first, second) => {
    return condition ? first : second
  },
  andCondition: (first, second) => {
    return first && second
  },
  orCondition: (first, second) => {
    return first || second
  },
  generatePassword: async length => {
    const passwordLength = length
    var numberChars = '0123456789'
    var upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    var lowerChars = 'abcdefghijklmnopqrstuvwxyz'
    var specialChars = '#?@$%&'
    var allChars = numberChars + upperChars + lowerChars + specialChars
    var randPasswordArray = Array(passwordLength)
    randPasswordArray[0] = numberChars
    randPasswordArray[1] = upperChars
    randPasswordArray[2] = lowerChars
    randPasswordArray[3] = specialChars
    randPasswordArray = randPasswordArray.fill(allChars, 4)
    return shuffleArray(
      randPasswordArray.map(function (x) {
        return x[Math.floor(Math.random() * x.length)]
      })
    ).join('')
  },
  calculateTotalTaskTime: (breakTimes, isBreak = true) => {
    let userBreak = breakTimes

    let totalBreakTime = '0 hours 0 minutes'
    if (userBreak?.length > 0) {
      let fullbreakTime = 0
      userBreak.map(data => {
        let startTime = new Date(data?.startTime)
        let endTime = new Date(data?.endTime)
        if (startTime && endTime) {
          let userTimeBreakDifference = endTime - startTime
          fullbreakTime +=
            userTimeBreakDifference > 0 ? userTimeBreakDifference : 0
        }
      })
      let fullBreakHours = Math.floor(fullbreakTime / (1000 * 60 * 60))
      let fullBreakMinutes = Math.ceil(
        (fullbreakTime % (1000 * 60 * 60)) / (1000 * 60)
      )
      totalBreakTime = `${fullBreakHours} hours ${fullBreakMinutes} minutes`
      if (!isBreak) return totalBreakTime
    }
    if (isBreak) return totalBreakTime
  },
  calculateTotalBreakTime: (breakTimes, breakEndTime) => {
    let userBreak = breakTimes

    let totalBreakTime = 0 + ' hours ' + 0 + ' minutes ' + 0 + ' seconds'
    if (userBreak?.length > 0) {
      let fullbreakTime = 0
      userBreak.map((data, i) => {
        let startBreakTime = new Date(data?.startBreakTime)
        let endBreakTime = new Date(data?.pause || breakEndTime)
        if (startBreakTime && endBreakTime) {
          let userTimeBreakDifference = endBreakTime - startBreakTime
          fullbreakTime +=
            userTimeBreakDifference > 0 ? userTimeBreakDifference : 0
        }
      })
      let fullBreakhours = helpers.ternaryCondition(
        fullbreakTime > 0,
        Math.floor(fullbreakTime / (1000 * 60 * 60)),
        0
      )
      let fullBreakminutes = helpers.ternaryCondition(
        fullbreakTime > 0,
        Math.floor((fullbreakTime % (1000 * 60 * 60)) / (1000 * 60)),
        0
      )
      let fullBreakSeconds = helpers.ternaryCondition(
        fullbreakTime > 0,
        Math.floor((fullbreakTime % (1000 * 60)) / 1000),
        0
      )
      totalBreakTime =
        fullBreakhours +
        ' hours ' +
        fullBreakminutes +
        ' minutes ' +
        fullBreakSeconds +
        ' seconds'
      return totalBreakTime
    } else return totalBreakTime
  },
  calculateTotalWorkTime: ({
    punchInDateTime,
    punchOutDateTime,
    breakEndTime,
    breakTime
  }) => {
    let workingTime = '',
      breakingTime = ''
    const startDate = new Date(punchInDateTime).getTime()
    const endDate = new Date(punchOutDateTime).getTime()
    if (startDate && endDate) {
      workingTime = timeSince(startDate, endDate)
      breakingTime = helpers.calculateTotalBreakTime(
        breakTime,
        breakEndTime,
        false
      )
      workingTime = splitTime(workingTime)
      breakingTime = splitTime(breakingTime)
      const hours = workingTime?.hours - (breakingTime?.hours || 0)
      const { minute, second: seconds } = minuteTime(workingTime, breakingTime)
      workingTime = `${hours > 0 ? hours : 0} hours ${
        minute > 0 ? minute : 0
      } minutes ${seconds > 0 ? seconds : 0} seconds`
    } else workingTime = 'N/A'
    return workingTime
  },
  handleResult: (condition, successCallback, errorCallback) => {
    if (condition) {
      successCallback()
    } else {
      errorCallback()
    }
  },
  performOperationIf (condition, operationAsCallback) {
    if (condition) {
      operationAsCallback()
    }
  },

  /**
   * Confirmation modal that accepts Bootstrap-styled HTML content.
   */
  confirmWithHtml: function (htmlContent, item, onConfirm) {
    MySwal.fire({
      html: htmlContent,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#3b82f6',
      cancelButtonColor: '#6b7280',
      reverseButtons: true,
      focusConfirm: false,
      customClass: {
        popup: 'text-start',
        htmlContainer: 'text-start m-0',
      },
    }).then((result) => {
      if (result.isConfirmed && typeof onConfirm === 'function') {
        onConfirm(item)
      }
    })
  },

  /**
   * Billing confirmation popup — "this cycle only" layout.
   */
  buildBillingChangeHtml: function ({
    isNew = false,
    // Add mode
    currentLedger = 0,
    newBudget,
    newDuration,
    newThisCycle,
    runningTotal,
    // Edit mode
    oldBudget,
    oldDuration,
    oldThisCycle,
    newThisCycle: newThisCycleEdit, // alias for edit
    newBudget: newBudgetEdit,
    newDuration: newDurationEdit,
  }) {
    const num = (v) => {
      const n = Number(v);
      return Number.isFinite(n) ? n : 0;
    };
    const money = (n) => `$${num(n).toFixed(2)}`;
    const signed = (n) =>
      `${num(n) > 0 ? '+' : num(n) < 0 ? '-' : ''}$${Math.abs(num(n)).toFixed(2)}`;
    const colorFor = (n) =>
      num(n) > 0 ? '#dc3545' : num(n) < 0 ? '#198754' : '#6c757d';

    const header = `
      <div style="font-weight:600;font-size:16px;color:#212529;margin-bottom:12px;">
        Confirm Billing Change
      </div>
    `;
    const tableStyle = `width:100%;border-collapse:collapse;font-size:13px;`;
    const thRight = `text-align:right;padding:6px 4px;font-weight:600;color:#6c757d;font-size:11px;text-transform:uppercase;`;
    const thLeft  = `text-align:left;padding:6px 4px;font-weight:600;color:#6c757d;font-size:11px;text-transform:uppercase;width:56%;`;
    const tdRight = `text-align:right;padding:6px 4px;`;
    const tdLeft  = `padding:6px 4px;color:#6c757d;`;
    const footer = `
      <div style="margin-top:12px;font-size:12px;color:#6c757d;text-align:left;">
        Amounts will be reflected in your monthly subscription invoice.
      </div>
    `;

    // ============ ADD MODE ============
    if (isNew) {
      const totalThisCycle = num(runningTotal) !== 0
        ? num(runningTotal)
        : num(currentLedger) + num(newThisCycle);

      return `
        <div style="text-align:left;font-family:inherit;">
          ${header}
          <table style="${tableStyle}">
            <thead>
              <tr>
                <th style="${thLeft}"></th>
                <th style="${thRight}">This Cycle</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="${tdLeft}">Current ledger</td>
                <td style="${tdRight}">${money(currentLedger)}</td>
              </tr>
              <tr>
                <td style="${tdLeft}">This job &mdash; $${num(newBudget)} / ${num(newDuration)}d</td>
                <td style="${tdRight}">${money(newThisCycle)}</td>
              </tr>
              <tr style="border-top:1px solid #e9ecef;">
                <td style="padding:8px 4px;font-weight:600;">Total after adding</td>
                <td style="padding:8px 4px;text-align:right;font-weight:600;color:#0d6efd;">
                  ${money(totalThisCycle)}
                </td>
              </tr>
            </tbody>
          </table>
          ${footer}
        </div>
      `;
    }

    // ============ EDIT MODE ============
    const editNewThis = num(newThisCycleEdit ?? newThisCycle);
    const editNewBudget = num(newBudgetEdit ?? newBudget);
    const editNewDuration = num(newDurationEdit ?? newDuration);
    const editOldThis = num(oldThisCycle);

    const diff = Math.round((editNewThis - editOldThis) * 100) / 100;

    return `
      <div style="text-align:left;font-family:inherit;">
        ${header}
        <table style="${tableStyle}">
          <thead>
            <tr>
              <th style="${thLeft}"></th>
              <th style="${thRight}">This Cycle</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="${tdLeft}">Old &mdash; $${num(oldBudget)} / ${num(oldDuration)}d</td>
              <td style="${tdRight}">${money(editOldThis)}</td>
            </tr>
            <tr>
              <td style="${tdLeft}">New &mdash; $${editNewBudget} / ${editNewDuration}d</td>
              <td style="${tdRight}">${money(editNewThis)}</td>
            </tr>
            <tr style="border-top:1px solid #e9ecef;">
              <td style="padding:8px 4px;font-weight:600;">Change</td>
              <td style="padding:8px 4px;text-align:right;font-weight:600;color:${colorFor(diff)};">
                ${signed(diff)}
              </td>
            </tr>
          </tbody>
        </table>
        ${footer}
      </div>
    `;
  },

  buildNoChangeHtml: function () {
    return `
      <div style="text-align:left;font-family:inherit;">
        <div style="font-weight:600;font-size:16px;color:#212529;margin-bottom:6px;">
          No Pricing Change
        </div>
        <div style="font-size:13px;color:#6c757d;">
          Budget and duration are unchanged. Save other changes?
        </div>
      </div>
    `;
  },
  confirmAlertFunction: (title, item, changeFunction, deleteIcon) => {
  return MySwal.fire({
    html: <strong>{title}</strong>,
    icon: deleteIcon ? 'error' : 'warning',
    showConfirmButton: 'Okay',
    showCancelButton: true,
    showLoaderOnConfirm: true,
    // Prevent closing on outside click / ESC while the async work runs
    allowOutsideClick: () => !Swal.isLoading(),
    allowEscapeKey: () => !Swal.isLoading(),
    preConfirm: async () => {
      try {
        // Return the promise so SweetAlert keeps the loader visible
        // until the async callback resolves.
        return await changeFunction(item)
      } catch (error) {
        // Surface the failure in the modal instead of hanging on the loader
        Swal.showValidationMessage(
          error?.message || 'Something went wrong. Please try again.'
        )
        throw error
      }
    },
  })
},
}

export default helpers

function timeSince (date1, date2) {
  let result = 0 + ' hours ' + 0 + ' minutes ' + 0 + ' seconds'
  if (date1 && date2) {
    const timeDifference = date2 - date1
    const hours = Math.floor(timeDifference / (1000 * 60 * 60))
    const minutes = Math.floor(
      (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
    )
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000)
    result = hours + ' hours ' + minutes + ' minutes ' + seconds + ' seconds'

    return result
  } else return result
}

function minuteTime (workingTime, breakingTime) {
  const allWorkingTime = workingTime?.minutes * 60 + (workingTime?.seconds || 0)
  const allBreakingTime =
    breakingTime?.minutes * 60 + (breakingTime?.seconds || 0)

  const minute = parseInt((allWorkingTime - allBreakingTime) / 60)
  const second = allWorkingTime - allBreakingTime - minute * 60

  return { minute, second }
}

function splitTime (time) {
  const timeArray = time.split(' ')

  const hours = parseInt(timeArray[0])
  const minutes = parseInt(timeArray[2])
  const seconds = parseInt(timeArray[4])

  return { hours, minutes, seconds }
}